import {
    DataBindingPropertyType,
    IMultiStageMapContainerControl,
    IViewSets,
    AnatomicMapButtons,
    SegmentLabels,
    MultistageMapLayoutMode
} from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';
import { rowProportional } from '../utils/control-grid';
import { AdditionalContentControlType, createAdditionalContent } from './cp-additional-content';
import { CpControl } from './cp-control';

export class CpMultiStageMapContainerControl extends CpControl {
    readonly controlTypeGroup = 'MultiStageMap';
    readonly dataBinding: DataBinding;
    readonly viewBinding?: DataBinding;
    readonly legendDataSource: string;
    readonly segmentsDataSource: string;
    readonly readOnly: boolean;
    readonly required: boolean;
    readonly selectOnly: boolean;
    readonly viewIdProperty?: DataBindingPropertyType; // IdUsStressView
    readonly stageSegments: DataBindingPropertyType; //LVKinetic
    readonly stageNameProperty: DataBindingPropertyType; //DicomDescription
    readonly stageOrderProperty: DataBindingPropertyType; //DicomOrder
    readonly stageViewImageBinding?: DataBindingPropertyType;
    readonly legendImageBinding?: DataBinding;
    readonly stageIsToPrint?: DataBindingPropertyType; //IsToPrint
    readonly segmentLabelType?: SegmentLabels;
    readonly isHorizontal?: boolean;
    readonly legendActionsConfiguration?: AnatomicMapButtons[];
    readonly isWithTooltip?: boolean;
    readonly isWithStageName?: boolean;
    readonly isWithViewId?: boolean;
    readonly fixedViewsColNumber?: number;
    readonly viewTopLabel?: string | DataBindingPropertyType;
    readonly viewBottomLabel?: string | DataBindingPropertyType;
    readonly viewSetBinding?: DataBinding;
    readonly viewsSets?: IViewSets = <IViewSets>{};
    readonly additionalContent?: AdditionalContentControlType[];
    readonly layoutMode?: MultistageMapLayoutMode;

    constructor(control: IMultiStageMapContainerControl, dataBindingContext?: DataBinding) {
        super(control);
        const config = control.config[0];
        this.dataBinding = new DataBinding(config.dataBinding, dataBindingContext);
        this.viewBinding = config.viewBinding ? new DataBinding(config.viewBinding, dataBindingContext) : undefined;
        this.viewIdProperty = config.viewIdProperty ?? undefined;
        this.readOnly = config.readOnly;
        this.required = config.required;
        this.selectOnly = config.selectOnly ?? true;
        this.stageSegments = config.stageSegments ?? undefined;
        this.stageNameProperty = config.stageNameProperty ?? undefined;
        this.stageOrderProperty = config.stageOrderProperty ?? undefined;
        this.stageIsToPrint = config.stageIsToPrint ?? undefined;
        this.stageViewImageBinding = config.stageViewImageBinding ?? undefined;
        this.legendDataSource = config.legendDataSource ?? undefined;
        this.segmentsDataSource = config.segmentsDataSource ?? null;
        this.segmentLabelType = config.segmentLabelType ?? SegmentLabels.none;
        this.isHorizontal = config.isHorizontal ?? false;
        this.legendActionsConfiguration = config.legendActionsConfiguration ?? [];
        this.isWithTooltip = config.isWithTooltip ?? true;
        this.isWithStageName = config.isWithStageName ?? true;
        this.isWithViewId = config.isWithViewId ?? true;
        this.fixedViewsColNumber = config.fixedViewsColNumber ?? undefined;
        this.viewTopLabel = config.viewTopLabel ?? undefined;
        this.viewBottomLabel = config.viewBottomLabel ?? undefined;
        this.legendImageBinding = config.legendImageBinding
            ? new DataBinding(config.legendImageBinding, dataBindingContext)
            : undefined;
        this.viewSetBinding = config.viewSetBinding
            ? new DataBinding(config.viewSetBinding, dataBindingContext)
            : undefined;
        this.viewsSets = config.viewsSets ?? undefined;
        this.additionalContent = createAdditionalContent(control.additionalContent ?? [], dataBindingContext);
        this.layoutMode = config.layoutMode ?? undefined;
    }

    canAlignToBottom() {
        return true;
    }

    getHeightHint() {
        return rowProportional(this.rowSpan);
    }
}
